import { atom } from 'jotai/vanilla';

import { useAtomValue } from '@/utils/jotai-svelte';

import { onMountWithActiveText, teoActiveTextAtom } from '../teoAtom';

export const Analysis$ = teoActiveTextAtom((activeText) => activeText?.analysis);
Analysis$.onMount = onMountWithActiveText(({ refresh }, activeText) => {
  return activeText.events.addEventListener('gotAnalysis', refresh);
});

export const AnalysisState$ = teoActiveTextAtom((activeText) => activeText?.analysisState);
AnalysisState$.onMount = onMountWithActiveText(({ refresh }, activeText) => {
  return activeText.events.addEventListener('analysisStateChanged', refresh);
});

export const AnalysisData$ = atom((get) => get(Analysis$)?.data);
export const AnalysisStatistics$ = atom((get) => get(Analysis$)?.statistics);

export const TPI$ = atom((get) => get(Analysis$)?.getTPI());

export const useAnalysis = () => useAtomValue(Analysis$);
export const useAnalysisData = () => useAtomValue(AnalysisData$);
export const useAnalysisStatistics = () => useAtomValue(AnalysisStatistics$);
export const useTPI = () => useAtomValue(TPI$);

export const useAnalysisState = () => useAtomValue(AnalysisState$);
